import { useGetHotelDiscover as useGetHotelDiscoverNew } from 'app/hooks/data/core/admin/hotels/useGetHotelDiscover';
import {
  useGetHotelDiscover as useGetHotelDiscoverOld, //   useSaveHotelDiscover,
} from 'app/hooks/data/hotels/useHotelDiscover';

export const useGetHotelDiscover = ({
  hotelId,
  isLegacy,
}: {
  hotelId: number;
  isLegacy: boolean;
}) => {
  const oldQuery = useGetHotelDiscoverOld({
    hotelId,
    forceDisable: !isLegacy,
  });

  const newQuery = useGetHotelDiscoverNew({
    hotelId,
    forceDisable: isLegacy,
  });

  return isLegacy ? oldQuery : newQuery;
};
